import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { primaryShadow, responsive } from '@hivebrite/design-system/Theme';

import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const PublicationContentWrapper = ({ children }) => {
  const frameTheme = useFrameTheme();

  return (
    <ThemeProvider
      theme={frameTheme.themeName}
      fontBrightness={frameTheme.fontBrightness}
    >
      <WrapperStyled bg={frameTheme.backgroundColor}>{children}</WrapperStyled>
    </ThemeProvider>
  );
};

export default PublicationContentWrapper;

const WrapperStyled = styled(Box).attrs({
  display: 'block',
  px: { _: 4, m: 6, l: '80px', xl: '115px' },
  pt: 4,
  pb: { _: 6, l: 8 },
})`
  ${primaryShadow};
  ${responsive('m')`
    border-bottom-left-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
    border-bottom-right-radius: ${({ theme }) =>
      `${theme.themeVariables.globalBorderRadius}px`};
  `}
`;
